/**
 * constant to share inner styles between formkit and non-formkit input elements
 */
export const FIELD_INNER_STYLES =
  'bg-white border-2 border-slate-200 rounded-md focus-within:border-primary formkit-invalid:border-red formkit-invalid:focus-within:border-primary !w-full focus-within:shadow-sm w-full rounded-md h-11 relative disabled:cursor-not-allowed'
